import { RootState } from 'store';

export const selectAllowances = ({ careWorkers }: RootState) => careWorkers.userAllowances.rows;
